import React from 'react';

const Spacer = function(props) {
    return (
        <div className="spacer"></div>
    );
}

export default Spacer;
